import { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import RebateAggregateRow from '../sub-components/RebateAggregateRow';
import RebateBreakupRow from '../sub-components/RebateBreakupRow';
import WorkflowButton from '../sub-components/WorkflowButton';
import OverrideModal from '../sub-components/OverrideModal.jsx';
import PageReadOnlyInput from '../sub-components/PageReadOnlyInputCopy.jsx';
import PageDropdown from '../sub-components/PageDropdownCopy.jsx';
import WorkflowModal from '../sub-components/WorkflowModal';
import PageTabs from '../sub-components/PageTabsCopy.jsx'; 
import RebateSetupRow from '../sub-components/RebateSetupRow';
import SubCompanyRow from '../sub-components/SubCompanyRow';
import EditAccountIdsModal from '../sub-components/EditAccountIdsModal';
import StandardRowFormatted from '../sub-components/StandardRowFormatted';
import ProgramAdjustmentRow from '../sub-components/ProgramAdjustmentRow';
import { filterByPeriod, buildProgramLevelTotals, buildProgramAdjustmentRows } from '../functions/programAggregateHelpers';
import statusFilter from '../functions/statusFilter';
import EditPayoutTypeModal from '../sub-components/EditPayoutTypeModal';
import PayoutInfoRow from '../sub-components/PayoutInfoRow';
import { HttpContext } from '../../api-services/HttpService';
import standardFilter from '../functions/standardFilter';
import lessThanOrEqualFilter from '../functions/lessThanOrEqualFilter';
import applyFilters from '../functions/applyFilters';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import formatDate from '../functions/formatDate'; 
import AdhocDataRow from '../sub-components/AdhocDataRow';
// import EntitledButton from '../sub-components/EntitledButton'; 
import AddAdhocPaymentModal from '../sub-components/AddAdhocPaymentModal.jsx';  
import EditAdhocPaymentModal from '../sub-components/EditAdhocPaymentModal.jsx'; 
import AggregateTotalsFooter from '../sub-components/AggregateTotalsFooter'; 
import ConsortiumViewRow from '../sub-components/ConsortiumViewRow'; 
import ConsortiumViewFooter from '../sub-components/ConsortiumViewFooter'; 
import UploadContractRow from '../sub-components/UploadContractRow'; 
import ContractUploadCommentModal from '../sub-components/ContractUploadCommentModal';
import getPageTabs from '../functions/getPageTabs';
import BannerAlert from '../sub-components/BannerAlertCopy.jsx'; 
import MarkPaymentFailedModal from '../sub-components/MarkPaymentFailedModal.jsx'; 
import PageToggleButtonGroup from '../sub-components/PageToggleButtonGroupCopy.jsx';
import PayoutDetailsGraphs from '../sub-components/PayoutDetailsGraphs';
import { Box, Grid, styled, Typography } from '@mui/material';
import RebateComponentDisplay from '../sub-components/RebateComponentDisplayCopy.jsx';
import Footer from "../sub-components/Footer.tsx";
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import InfoLabel from '../sub-components/InfoLabel.jsx';
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import RebateSummaryIndicator from '../sub-components/RebateSummaryIndicator.jsx';
import { useNavigate } from 'react-router-dom';
import isNullUndefinedEmpty from '../functions/isNullUndefinedEmpty.js'; 
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 

//Styled Topography for table name
const TableName = styled(Typography)(({ theme }) => ({
    // background: "#E6F6FA",
    // color: "#3D3D3D",
    background: process.env.REACT_APP_LABEL_COLOR,
    color: `${process.env.REACT_APP_LABEL_TEXT_COLOR} !important`,
    justifyContent: "center",
    fontSize: "14px",
    minHeight: "40px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    fontFamily:"Roboto medium, Helvetica, Arial, sans-serif"
}));

const CompanyPayoutView = () =>{
    // initialize http context 
    const {
        GET,  
    } = useContext(HttpContext);
    // intialize default page tabs 
    const pageTabs = [
        {tag: 'Company ID List', key: 0, active: true}, 
        {tag: 'Current Cycle', key: 1, active: true}, 
        {tag: 'Historical Cycles', key: 2, active: true}, 
        {tag: 'Monthly Breakup', key: 3, active: true}, 
        {tag: 'Rebate Setups', key: 4, active: true}, 
        {tag: 'Payout Info', key: 5, active: true}, 
        {tag: 'Payment History', key: 6, active: true}, 
        {tag: 'Client Contracts', key: 7, active: process.env.REACT_APP_UPLOAD_CLIENT_CONTRACTS == '1'}, 
        // {tag: 'Consortium View', key: 8, active: false}, 
    ]; 
    // global redux state for company (passed in from other route)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    // initailize state for period id dropdowns
    const [periodId, setPeriodId] = useState('');
    const [periodList, setPeriodList] = useState(['']);
    const [periodIdHistorical, setPeriodIdHistorical] = useState('');
    const [periodListHistorical, setPeriodListHistorical] = useState(['']);
    // initialize state for tables 
    const [aggregateDataList, setAggregateDataList] = useState([]);
    const [showAggregateDataList, setShowAggregateDataList] = useState([]);
    const [aggregateTableHeader, setAggregateTableHeader] = useState([]);
    const [breakupDataList, setBreakupDataList] = useState([]);
    const [showBreakupDataList, setShowBreakupDataList] = useState([]);
    const [breakupTableHeader, setBreakupTableHeader] = useState([]);
    const [rebateSetupDataList, setRebateSetupDataList] = useState([]);
    const [showRebateSetupDataList, setShowRebateSetupDataList] = useState([]);
    const [rebateSetupTableHeader, setRebateSetupTableHeader] = useState([]);
    const [payoutInfoDataList, setPayoutInfoDataList] = useState([]);
    const [payoutInfoTableHeader, setPayoutInfoTableHeader] = useState([]);
    const [historicalAggregateDataList, setHistoricalAggregateDataList] = useState([]);
    const [showHistoricalAggregateDataList, setShowHistoricalAggregateDataList] = useState([]);
    const [historicalAggregateTableHeader, setHistoricalAggregateTableHeader] = useState([]);
    const [historicalBreakupDataList, setHistoricalBreakupDataList] = useState([]);
    const [showHistoricalBreakupDataList, setShowHistoricalBreakupDataList] = useState([]);
    const [historicalBreakupTableHeader, setHistoricalBreakupTableHeader] = useState([]);
    const [workflowAggregateDataList, setWorkflowAggregateDataList] = useState([]);
    const [workflowAggregateTableHeader, setWorkflowAggregateTableHeader] = useState([]);
    const [adhocDataList, setAdhocDataList] = useState([]); 
    const [adhocTableHeader, setAdhocTableHeader] = useState([]); 
    const [aggregateTotalsDataList, setAggregateTotalsDataList] = useState({}); 
    const [historicalTotalsDataList, setHistoricalTotalsDataList] = useState({});
    const [uploadContractsDataList, setUploadContractsDataList] = useState([]); 
    const [uploadContractsTableHeader, setUploadContractsTableHeader] = useState([]); 
    // initialize state for program level aggregate and program adjustment tables (current and historical cycle)
    const [programLevelAggregateDataList, setProgramLevelAggregateDataList] = useState([]);
    const [programLevelAggregateTableHeader, setProgramLevelAggregateTableHeader] = useState([]);
    const [programAdjustmentDataList, setProgramAdjustmentDataList] = useState([]);
    const [programAdjustmentTableHeader, setProgramAdjustmentTableHeader] = useState([]);
    const [historicalProgramLevelAggregateDataList, setHistoricalProgramLevelAggregateDataList] = useState([]);
    const [historicalProgramLevelAggregateTableHeader, setHistoricalProgramLevelAggregateTableHeader] = useState([]);
    const [historicalProgramAdjustmentDataList, setHistoricalProgramAdjustmentDataList] = useState([]);
    const [historicalProgramAdjustmentTableHeader, setHistoricalProgramAdjustmentTableHeader] = useState([]);
    // initialize state for sub company dropdown
    const [subCompany, setSubCompany] = useState('All');
    const [subCompanyList, setSubCompanyList] = useState(['All']);
    // initialize state for company id list tab
    const [subCompanyTableDataList, setSubCompanyTableDataList] = useState([]);
    const [showSubCompanyTableDataList, setShowSubCompanyTableDataList] = useState([]);
    const [subCompanyTableHeader, setSubCompanyTableHeader] = useState([]);
    const defaultCheckboxDropdownState = 'Active';
    const [activeTypeList] = useState(['All', 'Active', 'Inactive']);
    const [showInactiveSubcompanies, setShowInactiveSubcompanies] = useState(defaultCheckboxDropdownState);
    // initialize state for account ids view (company id list tab)
    const [editSubCompanyModal, setEditSubCompanyModal] = useState(false);
    const [editSubCompanyRow, setEditSubCompanyRow] = useState({});
    const [editAccountIdsModal, setEditAccountIdsModal] = useState(false);
    // initialize state for override modal
    const [editRow, setEditRow] = useState({});
    const [overrideModal, setOverrideModal] = useState(false);
    const [overrideTypeList, setOverrideTypeList] = useState(['']);
    const [overrideType, setOverrideType] = useState('');
    const [showOverride, setShowOverride] = useState(true);
    // initialize state for workflow modal 
    const [workflowModal, setWorkflowModal] = useState(false);
    const [workflowAction, setWorkflowAction] = useState('');
    const [workflowNewStatus, setWorkflowNewStatus] = useState('');
    const [workflowActionId, setWorkflowActionId] = useState(''); 
    // initialize reference for workflow modal
    const workflowButtonCss = useRef('modal-button-full-blue');
    const workflowOptOut = useRef(false);
    const workflowReviewAction = useRef(false);
    // initialize state for page tabs 
    const [tabValue, setTabValue] = useState(0);
    const [tabList, setTabList] = useState([]);
    // initialize state for edit payout info modal 
    const [editPayoutTypeModal, setEditPayoutTypeModal] = useState(false);
    // initialize spinner while data is loading
    const [showSpinner, setShowSpinner] = useState(false);
    const [showSpinnerHistorical, setShowSpinnerHistorical] = useState(false);
    // initialize state to trigger filter
    const [triggerFilter, setTriggerFilter] = useState(false);
    const [triggerFilterHistorical, setTriggerFilterHistorical] = useState(false);
    // initialize state for snackbar 
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // initialize state for user entitlement id
    const [userEntitlementId, setUserEntitlementId] = useState('');
    // initialize state for historical cycle
    const [historicalCycleStart, setHistoricalCycleStart] = useState('None');
    const [historicalCycleEnd, setHistoricalCycleEnd] = useState('None');
    // initialize state for master company status
    const [status, setStatus] = useState(companyInfo['status']);
    // initialize state to filter rebate setup page 
    const [productFilter, setProductFilter] = useState('All');
    const [productFilterList, setProductFilterList] = useState(['All']);
    const [feeCategoryFilter, setFeeCategoryFilter] = useState('All');
    const [feeCategoryFilterList, setFeeCategoryFilterList] = useState(['All']);
    const [billingRateFilter, setBillingRateFilter] = useState('All');
    const [billingRateFilterList, setBillingRateFilterList] = useState(['All']);
    const [rebateSetupTypeFilter, setRebateSetupTypeFilter] = useState('All'); 
    const [rebateSetupTypeList, setRebateSetupTypeList] = useState(['All']); 
    // initialize state to disable workflow button 
    const [disableWorkflowButton, setDisableWorkflowButton] = useState(false);
    // initialize state for add adhoc payment modal 
    const [showAddAdhocModal, setShowAddAdhocModal] = useState(false); 
    const [masterCompanyId, setMasterCompanyId] = useState(); 
    const [showEditAdhocModal, setShowEditAdhocModal] = useState(false); 
    const [editAdhocRow, setEditAdhocRow] = useState({}); 
    // bool to set edit rights for adhoc data table 
    const [adhocEditBool, setAdhocEditBool] = useState(false); 
    // initialize state for mark payment as failed modal 
    const [showMarkPaymentFailedModal, setShowMarkPaymentFailedModal] = useState(false); 
    const [markPaymentFailedRow, setMarkPaymentFailedRow] = useState({}); 
    // initialize state for enable reopen button 
    const [enableReopen, setEnableReopen] = useState(false); 
    // intialize state for rebate input type 
    const [rebateInputTypeId, setRebateInputTypeId] = useState(); 
    // intialize state for consortium tab
    const [consortiumDataList, setConsortiumDataList] = useState([]); 
    const [showConsortiumDataList, setShowConsortiumDataList] = useState([]); 
    const [consortiumTableHeader, setConsortiumTableHeader] = useState([]); 
    const [consortiumFlag, setConsortiumFlag] = useState(false); 
    const [consortiumId, setConsortiumId] = useState(''); 
    const [consortiumTotalsDataList, setConsortiumTotalsDataList] = useState({});
    // initialize state for contract tab
    const [showContractCommentModal, setShowContractCommentModal] = useState(false); 
    const [contractUploadRow, setContractUploadRow] = useState({}); 
    // initailize state to alert page refresh
    const [pageRefresh, setPageRefresh] = useState(false); 
    // initialize state for client info update alert
    const [showClientInfoUpdateAlert, setShowClientInfoUpdateAlert] = useState(false); 
     // initialize default radio buttons 
     const [radioButtons, setRadioButtons] = useState([
        {tag: 'Graphs', key: 1, active: process.env.REACT_APP_SPEND_GRAPHS == '1'}, 
        {tag: 'Data', key: 0, active: true}, 
    ]);     
    // initialize state to show graph components are loading
    const [isLoading, setIsLoading] = useState(false); 
    const [totalAggregateSpend, setTotalAggregateSpend] = useState(0); 
    const [radioKey, setRadioKey] = useState(parseInt(process.env.REACT_APP_INITIAL_KEY_COMPANY_PAYOUT_VIEW)); 
    // pie chart
    const [spendPieData, setSpendPieData] = useState([]); 
    // bar graph
    const [spendBarData, setSpendBarData] = useState([]); 
    const [spendBarKeys, setSpendBarKeys] = useState([]); 
    const [showSpendBarKeys, setShowSpendBarKeys] = useState([]); 
    const [spendBarYAxis, setSpendBarYAxis] = useState([]); 
    const [spendBarFilter, setSpendBarFilter] = useState(''); 
    const [spendBarFilterList, setSpendBarFilterList] = useState([]); 
    // Cycle Spend/Rebate YoY graph
    const [spendLineData, setSpendLineData] = useState([]); 
    const [spendLineKeys, setSpendLineKeys] = useState([]); 
    const [showSpendLineKeys, setShowSpendLineKeys] = useState([]); 
    const [spendLineXAxis, setSpendLineXAxis] = useState([]); 
    const [spendLineYAxis, setSpendLineYAxis] = useState([]); 
    const [showSpendLineYAxis, setShowSpendLineYAxis] = useState([]); 
    const [spendLineFilter, setSpendLineFilter] = useState([]); 
    const [spendLineFilterList, setSpendLineFilterList] = useState([]); 
    // Monthly Spend/Rebate YoY graph
    const [monthlyLineData, setMonthlyLineData] = useState([]); 
    const [monthlyLineKeys, setMonthlyLineKeys] = useState([]); 
    const [showMonthlyLineKeys, setShowMonthlyLineKeys] = useState([]); 
    const [monthlyLineXAxis, setMonthlyLineXAxis] = useState([]); 
    const [monthlyLineYAxis, setMonthlyLineYAxis] = useState([]); 
    const [showMonthlyLineYAxis, setShowMonthlyLineYAxis] = useState([]); 
    const [monthlyLineFilter, setMonthlyLineFilter] = useState([]); 
    const [monthlyLineFilterList, setMonthlyLineFilterList] = useState([]); 
    // initialize state for rebate components 
    const [rebateComponentConfig, setRebateComponentConfig] = useState([]); 
    const [rebateComponentValues, setRebateComponentValues] = useState({});
    const [masterCompanyData, setMasterCompanyData] = useState({}); 
    // state for true or false 
    const [trueObj, setTrueObj] = useState({label: 'Active', id: "true"}); 
    const [falseObj, setFalseObj] = useState({label: 'Inactive', id: "false"}); 
    // initialize state for adhoc input config
    const [adhocInputConfig, setAdhocInputConfig] = useState([]); 
    const [adhocInputLists, setAdhocInputLists] = useState({
        active: [trueObj, falseObj], 
        companyid: ['--select--']
    }); 
    // initialize monthly breakup radio button state 
    const [monthlyBreakupRadioKey, setMonthlyBreakupRadioKey] = useState(0); 
    const monthlyBreakupRadioButtons = [
        {tag: 'Current Cycle', key: 0, active: true}, 
        {tag: 'Historical Cycle', key: 1, active: true}, 
    ]; 
    // initialize rebate setups radio button state 
    const [rebateSetupsRadioKey, setRebateSetupsRadioKey] = useState(0); 
    const [rebateSetupsRadioButtons, setRebateSetupsRadioButtons] = useState([
        {tag: process.env.REACT_APP_MASTER_COMPANY_ID_TAG, key: 0, active: true}, 
        {tag: 'Consortium', key: 1, active: false}
    ]);  
    // initialize state for consortium rebate components/setups
    const [consortiumRebateSetupDataList, setConsortiumRebateSetupDataList] = useState([]); 
    const [showConsortiumRebateSetupDataList, setShowConsortiumRebateSetupDataList] = useState([]); 
    const [consortiumRebateSetupTableHeader, setConsortiumRebateSetupTableHeader] = useState([]); 
    const [consortiumRebateComponentValues, setConsortiumRebateComponentValues] = useState({}); 
    // initialize state for consortium rebate filters 
    const [consortiumProductFilter, setConsortiumProductFilter] = useState('All');
    const [consortiumFeeCategoryFilter, setConsortiumFeeCategoryFilter] = useState('All');
    const [consortiumBillingRateFilter, setConsortiumBillingRateFilter] = useState('All');
    const [consortiumRebateSetupTypeFilter, setConsortiumRebateSetupTypeFilter] = useState('All'); 
    // useRef for initial render 
    const initialRender1 = useRef(true);
    const initialRender2 = useRef(true);
    const initialRender3 = useRef(true);
    const initialRender4 = useRef(true);
    const initialRender5 = useRef(true);
    const initialRender6 = useRef(true); 
    const initialRender7 = useRef(true); 
    const initialRender8 = useRef(true); 
    const initialRender9 = useRef(true); 
    const initialRender10 = useRef(true); 
    const [enableResetHistoricalCycle, setEnableResetHistoricalCycle] = useState(false);
    const [enableResetRebateSetups1, setEnableResetRebateSetups1] = useState(false);
    const [enableResetRebateSetups2, setEnableResetRebateSetups2] = useState(false);
    const [enableReset, setEnableReset] = useState(false);
    const [isMenuLoaded, setIsMenuLoaded] = useState(false);
    // hook for navigation
    const navigate = useNavigate();

    // program level aggregate and program adjustment data for the current cycle (filtered by period)
    const showProgramLevelAggregateDataList = useMemo(() => filterByPeriod(programLevelAggregateDataList, periodId), [programLevelAggregateDataList, periodId]);
    const programLevelTotals = useMemo(() => buildProgramLevelTotals(showProgramLevelAggregateDataList), [showProgramLevelAggregateDataList]);
    const showProgramAdjustmentDataList = useMemo(() => buildProgramAdjustmentRows(filterByPeriod(programAdjustmentDataList, periodId), programLevelTotals['cycleincentiveamount']), [programAdjustmentDataList, periodId, programLevelTotals]);
    // program level aggregate and program adjustment data for the historical cycle (already returned for the selected historical period)
    const historicalProgramLevelTotals = useMemo(() => buildProgramLevelTotals(historicalProgramLevelAggregateDataList), [historicalProgramLevelAggregateDataList]);
    const showHistoricalProgramAdjustmentDataList = useMemo(() => buildProgramAdjustmentRows(historicalProgramAdjustmentDataList, historicalProgramLevelTotals['cycleincentiveamount']), [historicalProgramAdjustmentDataList, historicalProgramLevelTotals]);

    // function wrapper to pass row component to datatable
    const CurrentAggregateRowComponent = (row, count, tableHeader, stickyEnabled) =>{
        return( 
            <>
                <RebateAggregateRow row={row} count={count} tableHeader={tableHeader} showOverride={showOverride} stickyEnabled={stickyEnabled}/>
            </> 
        );   
    }  

    // function wrapper to pass row component to datatable
    const HistoricalAggregateRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <>
                <RebateAggregateRow row={row} count={count} tableHeader={tableHeader} showOverride={false} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // function wrapper to pass row component to datatable
    const BreakupRowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return( 
            <>
                <RebateBreakupRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled}/>
            </>
        );
    } 

    // function wrapper to pass row component to datatable
    const RebateSetupRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <>
                <RebateSetupRow row={row} count={count} tableHeader={tableHeader} enableEdit={false} stickyEnabled={stickyEnabled}/>
            </>
        )
    }

    // function wrapper to pass row component to datatable
    const SubCompanyRowComponent = (row, count, tableHeader, stickyEnabled) => {
        return (
            <>
                <SubCompanyRow row={row} count={count} tableHeader={tableHeader} enableEdit={false} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // function wrapper to pass row component to datatable
    const ProgramLevelAggregateRowComponent = (row, count, tableHeader, stickyEnabled) => {
        return (
            <>
                <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} rateTypeId={rebateInputTypeId} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // function wrapper to pass row component to datatable
    const ProgramAdjustmentRowComponent = (row, count, tableHeader, stickyEnabled) => {
        return (
            <>
                <ProgramAdjustmentRow row={row} count={count} tableHeader={tableHeader} rateTypeId={rebateInputTypeId} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // function wrapper to pass row component to datatable
    const PayoutInfoRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <>
                <PayoutInfoRow row={row} count={count} tableHeader={tableHeader} enableEdit={false} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // function wrapper to pass row component to datatable
    const AdhocRowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return( 
            <>
                <AdhocDataRow row={row} count={count} tableHeader={tableHeader} editBool={adhocEditBool} stickyEnabled={stickyEnabled}/>
            </>
        );
    } 

    // function wrapper to pass footer to datatable (totals row is boxed with the primary color)
    const ProgramLevelFooterComponent = (tableHeader, footerObj, stickyEnabled) => {
        return (
            <>
                <AggregateTotalsFooter tableHeader={tableHeader} footerObj={footerObj} rebateInputTypeId={rebateInputTypeId} stickyEnabled={stickyEnabled} boxColor={process.env.REACT_APP_PRIMARY_COLOR}/>
            </>
        ); 
    }

    // function wrapper to pass footer to datatable
    const FooterComponent = (tableHeader, footerObj,stickyEnabled) => {
        return (
            <>
                <AggregateTotalsFooter tableHeader={tableHeader} footerObj={footerObj} rebateInputTypeId={rebateInputTypeId} stickyEnabled={stickyEnabled}/>
            </>
        ); 
    }

    // function wrapper to pass footer to datatable
    const ConsortiumFooterComponent = (tableHeader, footerObj,stickyEnabled) => {
        return (
            <>
                <ConsortiumViewFooter tableHeader={tableHeader} footerObj={footerObj} stickyEnabled={stickyEnabled}/>
            </>
        )
    }

    // funciton wrapper to pass row component to datatable
    const ConsortiumViewRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <ConsortiumViewRow row={row} count={count} tableHeader={tableHeader} enableEdit={false} stickyEnabled={stickyEnabled}/>
        ); 
    }

    // function wrapper to pass row component to datatable 
    const UploadContractRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <>
                <UploadContractRow row={row} count={count} tableHeader={tableHeader} enableEdit={false} stickyEnabled={stickyEnabled}/>
            </>
        );
    }
    
    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // event handler for spend bar click. Must have args: (event, d)
    const onSpendPieClick = (event, d) => {
        // get company id from index
        console.log(spendPieData[0][d['dataIndex']]); 
        setSubCompany(subCompany => subCompany = spendPieData[0][d['dataIndex']]['companyid']); 
    }

    //reset functionality 
    const resetToDefault = () => {
        setSubCompany('All');
        setPeriodId(periodList[0]);
        resetToDefaultHistoricalCycle();
        resetToDefaultRebateSetups1();
        resetToDefaultRebateSetups2();
    }

    const enableResetAll = () => {
        if(enableResetHistoricalCycle || enableResetRebateSetups1 || enableResetRebateSetups2 || subCompany !== 'All' || periodId !== periodList[0]
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [subCompany, periodId, isMenuLoaded, enableResetHistoricalCycle, enableResetRebateSetups1, enableResetRebateSetups2])

    const resetToDefaultHistoricalCycle = () => {
        setPeriodIdHistorical(periodListHistorical[0]);
    }

    const enableResetAllHistoricalCycle = () => {
        if(periodIdHistorical !== periodListHistorical[0]
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAllHistoricalCycle()){
            setEnableResetHistoricalCycle(true);
        } else {
            setEnableResetHistoricalCycle(false);
        }
    }, [periodIdHistorical, isMenuLoaded])

    const resetToDefaultRebateSetups1 = () => {
        setConsortiumProductFilter('All');
        setConsortiumFeeCategoryFilter('All');
        setConsortiumBillingRateFilter('All');
        setConsortiumRebateSetupTypeFilter('All');
    }

    const enableResetAllRebateSetups1 = () => {
        if(consortiumProductFilter !== 'All' || consortiumFeeCategoryFilter !== 'All' ||
            consortiumBillingRateFilter !== 'All' || consortiumRebateSetupTypeFilter !== 'All'
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAllRebateSetups1()){
            setEnableResetRebateSetups1(true);
        } else {
            setEnableResetRebateSetups1(false);
        }
    }, [consortiumProductFilter, consortiumFeeCategoryFilter, consortiumBillingRateFilter, consortiumRebateSetupTypeFilter, isMenuLoaded])

    const resetToDefaultRebateSetups2 = () => {
        setProductFilter('All');
        setFeeCategoryFilter('All');
        setBillingRateFilter('All');
        setRebateSetupTypeFilter('All');
    }

    const enableResetAllRebateSetups2 = () => {
        if(productFilter !== 'All' || feeCategoryFilter !== 'All' ||
            billingRateFilter !== 'All' || rebateSetupTypeFilter !== 'All'
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAllRebateSetups2()){
            setEnableResetRebateSetups2(true);
        } else {
            setEnableResetRebateSetups2(false);
        }
    }, [productFilter, feeCategoryFilter, billingRateFilter, rebateSetupTypeFilter, isMenuLoaded])


    // calculate totals from the show aggregate list 
    const calculateAggregateTotals = (object, setObject, showDataList) => {
        return new Promise((resolve, reject) => {
            // initialize obj
            let totals = {
                companyname: 'Totals: ', 
                cyclenetspend: 0, 
                cyclenetinterchange: 0, 
                cycleincentiveamount: 0, 
            }; 
            // add all vals in showDataList elements to totals
            for (let i = 0; i < showDataList?.length; i++){
                if (showDataList[i]['cyclenetspend']){
                    totals['cyclenetspend'] = totals['cyclenetspend'] + parseFloat(showDataList[i]['cyclenetspend']); 
                }
                if (showDataList[i]['cyclenetinterchange']){
                    totals['cyclenetinterchange'] = totals['cyclenetinterchange'] + parseFloat(showDataList[i]['cyclenetinterchange']); 
                }
                if (showDataList[i]['cycleincentiveamount']){
                    totals['cycleincentiveamount'] = totals['cycleincentiveamount'] + parseFloat(showDataList[i]['cycleincentiveamount']); 
                } 
            }
            // set estimated rebate amount ( cycleincentiveamount / cyclenetspend )
            if (totals['cycleincentiveamount'] != 0){
                totals['incentiverate'] = (totals['cycleincentiveamount'] / totals['cyclenetspend']).toFixed(4); 
            }
            // set state
            setObject(object => object = totals); 
            // resolve
            resolve(totals); 
        })
    }

    // calculate totals for consortium show data list
    const consortiumCalculateAggregateTotals = (object, setObject, showDataList) => {
        return new Promise((resolve, reject) => {
            // initialize obj
            let totals = {
                mastercompanyname: 'Totals: ', 
                cyclegrossspend: 0, 
                cyclegrossinterchange: 0,  
                ytdgrossspend: 0, 
                ytdgrossinterchange: 0,                
            }; 
            // add all vals in showDataList elements to totals
            for (let i = 0; i < showDataList.length; i++){
                Object.keys(totals).map( el => {
                    if (showDataList[i][el] && el != 'mastercompanyname'){
                        totals[el] = totals[el] + parseFloat(showDataList[i][el]); 
                    }
                });
            }
            // set state
            setObject(object => object = totals); 
            // resolve
            resolve(totals); 
        })
    }

    // get all data to render on page from data endpoint
    const getCompanyPayoutViewPageData = () => {
        // show spinner while getting data
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            // use GET function to make request
            GET('/aggregates/companyPayoutViewPage', {
                mastercompanyid: companyInfo['mastercompanyid'], 
                mastercompanyname: company, 
                cyclestart: companyInfo['cyclestart'], 
                cycleend: companyInfo['cycleend'], 
                workflowid: companyInfo['workflowid'], 
            }).then(res => {
                console.log(res); 
                // set state for rebate setup table
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = res['data']['RebateSetupData']);
                setShowRebateSetupDataList(showRebateSetupDataList => showRebateSetupDataList = res['data']['RebateSetupData']);
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['RebateSetupCols']);
                // set state for company id list table
                setSubCompanyTableDataList(subCompanyTableDataList => subCompanyTableDataList = res['data']['SubCompanyTableData']);
                setShowSubCompanyTableDataList(showSubCompanyTableDataList => showSubCompanyTableDataList = res['data']['SubCompanyTableData']);
                setSubCompanyTableHeader(subCompanyTableHeader => subCompanyTableHeader = res['data']['SubCompanyTableCols']);
                // set state for payout info table 
                setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = res['data']['PayoutInfoData']);
                setPayoutInfoTableHeader(payoutInfoTableHeader => payoutInfoTableHeader = res['data']['PayoutInfoCols']);
                // set state for adhoc table 
                setAdhocDataList(adhocDataList => adhocDataList = res['data']['AdhocTableData']); 
                setAdhocTableHeader(adhocTableHeader => adhocTableHeader = res['data']['AdhocTableCols']); 
                // set state for rebate aggregate
                setAggregateDataList(aggregateDataList => aggregateDataList = res['data']['RebateCycleAggregateData']);
                setShowAggregateDataList(showAggregateDataList => showAggregateDataList = res['data']['RebateCycleAggregateData']);
                setAggregateTableHeader(aggregateTableHeader => aggregateTableHeader = res['data']['RebateCycleAggregateCols'])
                // set state for program level aggregate and program adjustment
                setProgramLevelAggregateDataList(programLevelAggregateDataList => programLevelAggregateDataList = res['data']['ProgramLevelAggregateData'] ?? []);
                setProgramLevelAggregateTableHeader(programLevelAggregateTableHeader => programLevelAggregateTableHeader = res['data']['ProgramLevelAggregateCols'] ?? []);
                setProgramAdjustmentDataList(programAdjustmentDataList => programAdjustmentDataList = res['data']['ProgramAdjustmentData'] ?? []);
                setProgramAdjustmentTableHeader(programAdjustmentTableHeader => programAdjustmentTableHeader = res['data']['ProgramAdjustmentCols'] ?? []);
                // set state for monthly breakup
                setBreakupDataList(breakupDataList => breakupDataList = res['data']['MonthlyBreakupData']);
                setShowBreakupDataList(showBreakupDataList => showBreakupDataList = res['data']['MonthlyBreakupData']);
                setBreakupTableHeader(breakupTableHeader => breakupTableHeader = res['data']['MonthlyBreakupCols']);
                // set period dropdown state
                setPeriodId(periodId => periodId = res['data']['PeriodIdList'][0]);
                setPeriodList(periodList => periodList = res['data']['PeriodIdList']);
                // set historical period dropdown state
                setPeriodIdHistorical(periodIdHistorical => periodIdHistorical = res['data']['HistoricalPeriodIdList'][0]);
                setPeriodListHistorical(periodListHistorical => periodListHistorical = res['data']['HistoricalPeriodIdList']);
                // set sub company dropdown state
                setSubCompany(subCompany => subCompany = 'All'); 
                setSubCompanyList(subCompanyList => subCompanyList = ['All', ...res['data']['SubCompanyList']]);
                // set override type list 
                setOverrideType(overrideType => overrideType = res['data']['OverrideTypeList'][0]);
                setOverrideTypeList(overrideTypeList => overrideTypeList = res['data']['OverrideTypeList']);
                // set user entitlement id 
                setUserEntitlementId(userEntitlementId => userEntitlementId = res['data']['UserEntitlementId']);
                // set workflow modal state
                setWorkflowAggregateTableHeader(workflowAggregateTableHeader => workflowAggregateTableHeader = res['data']['WorkflowAggregateCols']);
                // take largest period id for each company for workflowAggregateDataList
                let temp = [];
                for (let i = 0; i < res['data']['RebateCycleAggregateData'].length; i++){
                    if (res['data']['RebateCycleAggregateData'][i]['periodid'] == res['data']['PeriodIdList'][0]){
                        temp.push(res['data']['RebateCycleAggregateData'][i]);
                    }
                }
                setWorkflowAggregateDataList(workflowAggregateDataList => workflowAggregateDataList = temp);
                // set state for status
                setStatus(status => status = res['data']['WorkflowStatus']);
                // set state for rebate setup filters
                setProductFilterList(productFilterList => productFilterList = ['All', ...res['data']['ProductTypeList']]);
                setFeeCategoryFilterList(feeCategoryFilterList => feeCategoryFilterList = ['All', ...res['data']['FeeCategoryList']]);
                setBillingRateFilterList(billingRateFilterList => billingRateFilterList = ['All', ...res['data']['BillingRateList']]);
                setRebateSetupTypeList(rebateSetupTypeList => rebateSetupTypeList = ['All', ...res['data']['RebateSetupTypeList']]); 
                // set entitlement bool for adhoc data table add/edit 
                setAdhocEditBool(adhocEditBool => adhocEditBool = res['data']['AdhocEntitlement']); 
                // set state for enable reopen 
                setEnableReopen(enableReopen => enableReopen = res['data']['AllowReopen']); 
                // set state for rebate rate input type id
                setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']); 
                // set state for consortium view 
                setConsortiumDataList(consortiumDataList => consortiumDataList = res['data']['ConsortiumDataList']); 
                setShowConsortiumDataList(showConsortiumDataList => showConsortiumDataList = res['data']['ConsortiumDataList']); 
                setConsortiumTableHeader(consortiumTableHeader => consortiumTableHeader = res['data']['ConsortiumCols']); 
                setConsortiumId(consortiumId => consortiumId = res['data']['ConsortiumId']); 
                setConsortiumFlag(consortiumFlag => consortiumFlag = res['data']['ConsortiumFlag']); 
                // set tabs depending on consortiumFlag
                if (res['data']['ConsortiumFlag'] == true){ 
                    setTabList(tabList => tabList = getPageTabs(pageTabs, [{tag: 'Consortium View', key: 8, active: true}]));
                }
                else {
                    setTabList(tabList => tabList = getPageTabs(pageTabs));
                    // change tabValue if it is greater than equal to 5 (tabList.length)
                    if(tabValue == 8){
                        setTabValue(tabValue => tabValue = 0); 
                    }
                }
                // set rebate setups radio buttons depending on consortiumFlag 
                let temp1 = rebateSetupsRadioButtons; 
                for (let i = 0; i < temp1.length; i++) {
                    if (temp1[i]['key'] === 1) { // key for consortium button 
                        temp1[i]['active'] = res['data']['ConsortiumFlag']; 
                        break; 
                    }
                }
                setRebateSetupsRadioButtons(rebateSetupsRadioButtons => rebateSetupsRadioButtons = temp1); 
                // reset rebateSetupsRadioKey if non consortium 
                
                setRebateSetupsRadioKey(rebateSetupsRadioKey => rebateSetupsRadioKey = 0); 
               
                // set state for consortium rebate components/setups
                setConsortiumRebateSetupDataList(consortiumRebateSetupDataList => consortiumRebateSetupDataList = res['data']['ConsortiumRebateSetupData']); 
                setShowConsortiumRebateSetupDataList(showConsortiumRebateSetupDataList => showConsortiumRebateSetupDataList = res['data']['ConsortiumRebateSetupData']); 
                setConsortiumRebateSetupTableHeader(consortiumRebateSetupTableHeader => consortiumRebateSetupTableHeader = res['data']['ConsortiumRebateSetupCols']);
                setConsortiumRebateComponentValues(consortiumRebateComponentValues => consortiumRebateComponentValues = res['data']['ConsortiumRebateComponentValues']); 
                // set state for upload contract table 
                setUploadContractsDataList(uploadContractsDataList => uploadContractsDataList = res['data']['UploadContractsData']); 
                setUploadContractsTableHeader(uploadContractsTableHeader => uploadContractsTableHeader = res['data']['UploadContractsCols']); 
                // set state for client info update alert banner 
                setShowClientInfoUpdateAlert(showClientInfoUpdateAlert => showClientInfoUpdateAlert = res['data']['ClientInfoUpdateAlert']); 
                // set state for rebate components 
                setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = res['data']['RebateComponentConfig']); 
                setRebateComponentValues(rebateComponentValues => rebateComponentValues = res['data']['RebateComponentValues']); 
                setMasterCompanyData(masterCompanyData => masterCompanyData = res['data']['MasterCompanyData']); 
                // set state for input configs 
                setAdhocInputConfig(adhocInputConfig => adhocInputConfig = res['data']['AdhocInputConfig']); 
                setAdhocInputLists(adhocInputLists => adhocInputLists = {
                    active: [trueObj, falseObj], 
                    companyid: res['data']['SubCompanyList']
                }); 
                // trigger filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter);
                // change page refresh to alert useEffects
                setPageRefresh(pageRefresh => pageRefresh = !pageRefresh); 
                // make show spinner false 
                setShowSpinner(showSpinner => showSpinner = false);
                resolve(res); 
                setIsMenuLoaded(true);
            }).catch(err => {
                // make show spinner false 
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
                setIsMenuLoaded(false);
            });
        });
    }

    // // this function has been retired. Update if un-retiring
    // const onWebsocketRefresh = () => {
    //     return new Promise((resolve, reject) => {
    //         // use GET function to make request
    //         GET('/aggregates/companyPayoutViewPage', {
    //             mastercompanyid: companyInfo['mastercompanyid'], 
    //             mastercompanyname: company, 
    //             cyclestart: companyInfo['cyclestart'], 
    //             cycleend: companyInfo['cycleend'], 
    //             workflowid: companyInfo['workflowid'], 
    //         }).then(res => {
    //             // set state for rebate setup table
    //             setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = res['data']['RebateSetupData']);
    //             setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['RebateSetupCols']);
    //             // set state for payout info table 
    //             setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = res['data']['PayoutInfoData']);
    //             setPayoutInfoTableHeader(payoutInfoTableHeader => payoutInfoTableHeader = res['data']['PayoutInfoCols']);
    //             // set state for adhoc table 
    //             setAdhocDataList(adhocDataList => adhocDataList = res['data']['AdhocTableData']); 
    //             setAdhocTableHeader(adhocTableHeader => adhocTableHeader = res['data']['AdhocTableCols']); 
    //             // set state for rebate aggregate
    //             setAggregateDataList(aggregateDataList => aggregateDataList = res['data']['RebateCycleAggregateData']);
    //             setShowAggregateDataList(showAggregateDataList => showAggregateDataList = res['data']['RebateCycleAggregateData']);
    //             setAggregateTableHeader(aggregateTableHeader => aggregateTableHeader = res['data']['RebateCycleAggregateCols'])
    //             // set state for monthly breakup
    //             setBreakupDataList(breakupDataList => breakupDataList = res['data']['MonthlyBreakupData']);
    //             setShowBreakupDataList(showBreakupDataList => showBreakupDataList = res['data']['MonthlyBreakupData']);
    //             setBreakupTableHeader(breakupTableHeader => breakupTableHeader = res['data']['MonthlyBreakupCols']);
    //             // set state for status
    //             setStatus(status => status = res['data']['WorkflowStatus']);
    //             // trigger filter
    //             setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter);
    //             resolve(res);
    //         }).catch(err => {
    //             reject(err);
    //         });
    //     });
    // }

    // function to make get request to historical cycle endpoint
    const getHistoricalCycleData = () => {
        // show spinner while waiting for response
        setShowSpinnerHistorical(showSpinnerHistorical => showSpinnerHistorical = true);
        return new Promise((resolve, reject) => {
            // use GET function to make request
            GET('/aggregates/historicalCycle', {
                mastercompanyid: companyInfo['mastercompanyid'],
                periodid: periodIdHistorical, 
            }).then(res => {
                // set historical rebate aggregate state 
                setHistoricalAggregateDataList(historicalAggregateDataList => historicalAggregateDataList = res['data']['HistoricalRebateCycleAggregateData']);
                setShowHistoricalAggregateDataList(showHistoricalAggregateDataList => showHistoricalAggregateDataList = res['data']['HistoricalRebateCycleAggregateData']);
                setHistoricalAggregateTableHeader(historicalAggregateTableHeader => historicalAggregateTableHeader = res['data']['HistoricalRebateCycleAggregateCols']);
                // set historical program level aggregate and program adjustment state
                setHistoricalProgramLevelAggregateDataList(historicalProgramLevelAggregateDataList => historicalProgramLevelAggregateDataList = res['data']['HistoricalProgramLevelAggregateData'] ?? []);
                setHistoricalProgramLevelAggregateTableHeader(historicalProgramLevelAggregateTableHeader => historicalProgramLevelAggregateTableHeader = res['data']['HistoricalProgramLevelAggregateCols'] ?? []);
                setHistoricalProgramAdjustmentDataList(historicalProgramAdjustmentDataList => historicalProgramAdjustmentDataList = res['data']['HistoricalProgramAdjustmentData'] ?? []);
                setHistoricalProgramAdjustmentTableHeader(historicalProgramAdjustmentTableHeader => historicalProgramAdjustmentTableHeader = res['data']['HistoricalProgramAdjustmentCols'] ?? []);
                // set historical monthly breakup state
                setHistoricalBreakupDataList(historicalBreakupDataList => historicalBreakupDataList = res['data']['HistoricalMonthlyBreakupData']);
                setShowHistoricalBreakupDataList(showHistoricalBreakupDataList => showHistoricalBreakupDataList = res['data']['HistoricalMonthlyBreakupData']);
                setHistoricalBreakupTableHeader(historicalBreakupTableHeader => historicalBreakupTableHeader = res['data']['HistoricalMonthlyBreakupCols']);
                // set historical cycle start and end state
                setHistoricalCycleStart(historicalCycleStart => historicalCycleStart = res['data']['HistoricalCycleStart']);
                setHistoricalCycleEnd(historicalCycleEnd => historicalCycleEnd = res['data']['HistoricalCycleEnd']);  
                // hide spinner
                setShowSpinnerHistorical(showSpinnerHistorical => showSpinnerHistorical = false);
                // resolve on success
                setTriggerFilterHistorical(triggerFilterHistorical => triggerFilterHistorical = !triggerFilterHistorical);
                resolve(res);
            }).catch(err => {
                // hide spinner
                setShowSpinnerHistorical(showSpinnerHistorical => showSpinnerHistorical = false);
                // reject on error
                reject(err);
            });
        });
    }

    // make get request 
    const getGraphData = () => {
        return new Promise ((resolve, reject) => {
            // show loading
            setIsLoading(isLoading => isLoading = true); 
            // make request 
            GET('/graphs/CompanyPayoutViewPage', {
                mastercompanyid: companyInfo['mastercompanyid'], 
                workflowid: companyInfo['workflowid'], 
            }).then(res => {
                console.log(res); 
                // set state for pie chart
                setTotalAggregateSpend(totalAggregateSpend => totalAggregateSpend = res['data']['TotalAggregateSpend']); 
                setSpendPieData(spendPieData => spendPieData = res['data']['SpendPieData']); 
                // set state for spend bar
                setSpendBarData(spendBarData => spendBarData = res['data']['SpendBarData']); 
                setSpendBarKeys(spendBarKeys => spendBarKeys = res['data']['SpendBarKeys']); 
                setShowSpendBarKeys(showSpendBarKeys => showSpendBarKeys = res['data']['SpendBarKeys']); 
                setSpendBarYAxis(spendBarYAxis => spendBarYAxis = res['data']['SpendBarYAxis']); 
                setSpendBarFilter(spendBarFilter => spendBarFilter = res['data']['SpendBarFilters'][0]); 
                setSpendBarFilterList(spendBarFilterList => spendBarFilterList = res['data']['SpendBarFilters']); 
                // set state for spend line 
                setSpendLineData(spendLineData => spendLineData = res['data']['SpendLineData']); 
                setSpendLineKeys(spendLineKeys => spendLineKeys = res['data']['SpendLineKeys']);
                setShowSpendLineKeys(showSpendLineKeys => showSpendLineKeys = res['data']['SpendLineKeys']);
                setSpendLineXAxis(spendLineXAxis => spendLineXAxis = res['data']['SpendLineXAxis']);  
                setSpendLineYAxis(spendLineYAxis => spendLineYAxis = res['data']['SpendLineYAxis']); 
                setShowSpendLineYAxis(showSpendLineYAxis => showSpendLineYAxis = res['data']['SpendLineYAxis']); 
                setSpendLineFilter(spendLineFilter => spendLineFilter = res['data']['SpendLineFilters'][0]); 
                setSpendLineFilterList(spendLineFilterList => spendLineFilterList = res['data']['SpendLineFilters']); 
                // set state for monthly spend line 
                setMonthlyLineData(monthlyLineData => monthlyLineData = res['data']['MonthlyLineData']); 
                setMonthlyLineKeys(monthlyLineKeys => monthlyLineKeys = res['data']['MonthlyLineKeys']);
                setShowMonthlyLineKeys(showMonthlyLineKeys => showMonthlyLineKeys = res['data']['MonthlyLineKeys']);
                setMonthlyLineXAxis(monthlyLineXAxis => monthlyLineXAxis = res['data']['MonthlyLineXAxis']);  
                setMonthlyLineYAxis(monthlyLineYAxis => monthlyLineYAxis = res['data']['MonthlyLineYAxis']); 
                setShowMonthlyLineYAxis(showMonthlyLineYAxis => showMonthlyLineYAxis = res['data']['MonthlyLineYAxis']); 
                setMonthlyLineFilter(monthlyLineFilter => monthlyLineFilter = res['data']['MonthlyLineFilters'][0]); 
                setMonthlyLineFilterList(monthlyLineFilterList => monthlyLineFilterList = res['data']['MonthlyLineFilters']); 
                // hide loading
                setIsLoading(isLoading => isLoading = false); 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // hide loading
                setIsLoading(isLoading => isLoading = false); 
                // reject on error
                reject(err); 
            }); 
        }); 
    }

    // function for full refresh
    const fullRefresh = () => {
        return new Promise((resolve, reject) => {
            // refres page data 
            getCompanyPayoutViewPageData().then(res => {
                console.log(res); 
            }).catch(err => {
                console.log(err); 
            })
            // refresh graph data
            getGraphData().then(res => {
                console.log(res); 
            }).catch(err => {
                console.log(err); 
            }); 
        }); 
    }

    // useEffect to run on initial render
    useEffect(() => {
        // get data for graphs 
        getGraphData().then(res => {
            console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
    }, []);

    // useEffect to run on initial render
    useEffect(()=>{
        // re-route if no companyInfo
        if (isNullUndefinedEmpty(companyInfo)) {
            navigate('/RebateSummaryPage'); 
        }
        else {
             // re-route depending on workflowtypeid
            if (process.env.REACT_APP_BONUS_WORKFLOW_TYPE_ID === companyInfo['workflowtypeid']) {
                navigate('/CompanyBonusViewPage'); 
            }
            // set masterCompanyId for Adhoc modals 
            setMasterCompanyId(masterCompanyId => masterCompanyId = companyInfo['mastercompanyid']); 
            // get data to display
            getCompanyPayoutViewPageData('/aggregates/companyPayoutViewPage').then(res => {
                // console.log(res);
            }).catch(err => {
                console.log(err);
            });
        }
    }, [companyInfo]); 

    // useEffect to get historical data on period dropdown change
    useEffect(() => {
        if (periodIdHistorical != ''){
            getHistoricalCycleData().then(res => {
                console.log(res);
                // calculate totals 
                return calculateAggregateTotals(); 
            }).then(res => {
                // console.log(res); 
            }).catch(err => {
                console.log(err);
            });
        }
    }, [periodIdHistorical]);

    // useEffect to determine show override based on period
    useEffect(() => {
        // disable override when period is not last in cycle and user is a submitter
        if (userEntitlementId == process.env.REACT_APP_SUBMITTER_ROLE_ID 
        && !isNullUndefinedEmpty(companyInfo) && !isNullOrUndefined(companyInfo['cycleend'])
        && periodId == companyInfo['cycleend'].slice(0, 4) + '' + companyInfo['cycleend'].slice(5, 7)){
            setShowOverride(showOverride => showOverride = true);
        }
        else{
            setShowOverride(showOverride => showOverride = false);
        }
    }, [periodId, userEntitlementId, pageRefresh]);

    // useEffect to determine where to disable workflow button based on period 
    useEffect(() => {
        // disable workflow actio when period is not last in the cycle
        if (!isNullUndefinedEmpty(companyInfo) && !isNullOrUndefined(companyInfo['cycleend'])
        && periodId == companyInfo['cycleend'].slice(0, 4) + '' + companyInfo['cycleend'].slice(5, 7)){
            setDisableWorkflowButton(disableWorkflowButton => disableWorkflowButton = false); 
        }
        else {
            setDisableWorkflowButton(disableWorkflowButton => disableWorkflowButton = true);
        }
    }, [periodId, userEntitlementId, pageRefresh]); 

    // useEffect for sorting rebate cycle aggregate table 
    useEffect(() => {
        if (!initialRender1.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: periodId, flag: 1, cols: ['periodid']}, 
                {function: standardFilter, value: subCompany, flag: 1, cols: ['companyid']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(aggregateDataList, functionList);
            // update showDataList
            setShowAggregateDataList(showAggregateDataList => showAggregateDataList = filteredList);
            
        }
        else {
            initialRender1.current = false;
        }
    }, [periodId, subCompany, triggerFilter]);

    // useEffect for sorting monthly breakup table 
    useEffect(() => {
        if (!initialRender2.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: lessThanOrEqualFilter, value: periodId, flag: 1, cols: ['periodid']}, 
                {function: standardFilter, value: subCompany, flag: 1, cols: ['companyid']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(breakupDataList, functionList);
            // update showDataList
            setShowBreakupDataList(showBreakupDataList => showBreakupDataList = filteredList);
        }
        else {
            initialRender2.current = false;
        }
    }, [periodId, subCompany, triggerFilter]);

    // useEffect for filtering historical cycle aggregate and historical rebate breakup table 
    useEffect(() => {
        if (!initialRender3.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: subCompany, flag: 1, cols: ['companyid']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredListAggregate = applyFilters(historicalAggregateDataList, functionList);
            let filteredListBreakup = applyFilters(historicalBreakupDataList, functionList);
            // update showDataList
            setShowHistoricalAggregateDataList(showHistoricalAggregateDataList => showHistoricalAggregateDataList = filteredListAggregate);
            setShowHistoricalBreakupDataList(showHistoricalBreakupDataList => showHistoricalBreakupDataList = filteredListBreakup);
        }
        else {
            initialRender3.current = false; 
        }
    }, [subCompany, triggerFilterHistorical]);

    // filters for rebate setups table 
    useEffect(() => {
        // do not run on initial render
        if (!initialRender4.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: subCompany, flag: 1, cols: ['companyid']}, 
                {function: standardFilter, value: productFilter, flag: 1, cols: ['producttypedescription']}, 
                {function: standardFilter, value: feeCategoryFilter, flag: 1, cols: ['feecategorydescription']}, 
                {function: standardFilter, value: billingRateFilter, flag: 1, cols: ['billingratedescription']},
                {function: standardFilter, value: rebateSetupTypeFilter, flag: 1, cols: ['rebatesetuptypedescription']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(rebateSetupDataList, functionList);
            // update showDataList
            setShowRebateSetupDataList(showRebateSetupDataList => showRebateSetupDataList = filteredList);
        }
        else{
            initialRender4.current = false;
        }
    }, [subCompany, productFilter, feeCategoryFilter, billingRateFilter, billingRateFilter, rebateSetupTypeFilter, triggerFilter]);

    // filters for CONSORTIUM rebate setups table 
    useEffect(() => {
        // do not run on initial render
        if (!initialRender9.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: consortiumProductFilter, flag: 1, cols: ['producttypedescription']}, 
                {function: standardFilter, value: consortiumFeeCategoryFilter, flag: 1, cols: ['feecategorydescription']}, 
                {function: standardFilter, value: consortiumBillingRateFilter, flag: 1, cols: ['billingratedescription']},
                {function: standardFilter, value: consortiumRebateSetupTypeFilter, flag: 1, cols: ['rebatesetuptypedescription']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(consortiumRebateSetupDataList, functionList);
            // update showDataList
            setShowConsortiumRebateSetupDataList(showConsortiumRebateSetupDataList => showConsortiumRebateSetupDataList = filteredList);
        }
        else{
            initialRender9.current = false;
        }
    }, [ consortiumProductFilter, consortiumFeeCategoryFilter, consortiumBillingRateFilter, consortiumRebateSetupTypeFilter, triggerFilter]);


    // useEffect for sorting consortium view table
    useEffect(() => {
        if (!initialRender5.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: periodId, flag: 1, cols: ['periodid']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(consortiumDataList, functionList);
            // update showDataList
            setShowConsortiumDataList(showConsortiumDataList => showConsortiumDataList = filteredList);
            
        }
        else {
            initialRender5.current = false;
        }
    }, [periodId, triggerFilter]);

    // useEffect for filtering spend bar graph
    useEffect(() => {
        if (!initialRender6.current) {
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: subCompany, flag: 1, cols: ['companyid'], allOverride: true}, 
                {function: standardFilter, value: spendBarFilter['id'], flag: 1, cols: ['graphfilterid']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(spendBarKeys, functionList);
            // update show 
            setShowSpendBarKeys(showSpendBarKeys => showSpendBarKeys = filteredList); 
        }
        else { 
            initialRender6.current = false;
        }
    }, [spendBarFilter, subCompany]); 

    // useEffect for filterine spend bar graph 
    useEffect(() => {
        if (!initialRender7.current) {
            // FOR GRAPH DATA
            // declare list of functions with parameters to filter/search list
            const functionList1 = [
                {function: standardFilter, value: subCompany, flag: 1, cols: ['companyid'], allOverride: true}, 
                {function: standardFilter, value: spendLineFilter['id'], flag: 1, cols: ['graphfilterid']}, 
            ]
            // use applyFilters function to search by running all functions declared above
            let filteredList1 = applyFilters(spendLineKeys, functionList1);
            // update show 
            setShowSpendLineKeys(showSpendLineKeys => showSpendLineKeys = filteredList1); 
            // FOR GRAPH Y AXIS
            // declare list of functions with parameters to filter/search list
            const functionList2 = [
                {function: standardFilter, value: spendLineFilter['id'], flag: 1, cols: ['graphFilterId']}, 
            ]
            // use applyFilters function to search by running all functions declared above
            let filteredList2 = applyFilters(spendLineYAxis, functionList2);
            // update show 
            setShowSpendLineYAxis(showSpendLineYAxis => showSpendLineYAxis = filteredList2);
        }
        else {
            initialRender7.current = false; 
        }
    }, [spendLineFilter, subCompany]); 

    // useEffect for filterine monthly bar graph 
    useEffect(() => {
        if (!initialRender8.current) {
            // FOR GRAPH DATA
            // declare list of functions with parameters to filter/search list
            const functionList1 = [
                {function: standardFilter, value: subCompany, flag: 1, cols: ['companyid'], allOverride: true}, 
                {function: standardFilter, value: monthlyLineFilter['id'], flag: 1, cols: ['graphfilterid']}, 
            ]
            // use applyFilters function to search by running all functions declared above
            let filteredList1 = applyFilters(monthlyLineKeys, functionList1);
            // update show 
            setShowMonthlyLineKeys(showMonthlyLineKeys => showMonthlyLineKeys = filteredList1); 
            // FOR GRAPH Y AXIS
            // declare list of functions with parameters to filter/search list
            const functionList2 = [
                {function: standardFilter, value: monthlyLineFilter['id'], flag: 1, cols: ['graphFilterId']}, 
            ]
            // use applyFilters function to search by running all functions declared above
            let filteredList2 = applyFilters(monthlyLineYAxis, functionList2);
            // update show 
            setShowMonthlyLineYAxis(showMonthlyLineYAxis => showMonthlyLineYAxis = filteredList2);
        }
        else {
            initialRender8.current = false; 
        }
    }, [monthlyLineFilter, subCompany]); 
 
    // useEffect for calculating aggregate totals on showAggregateDataList change
    useEffect(() => {
        // calculate totals for aggregate table
        calculateAggregateTotals(aggregateTotalsDataList, setAggregateTotalsDataList, showAggregateDataList).then(res => {
            // console.log(res);
        }).catch(err => {
            console.log(err); 
        }); 
    }, [showAggregateDataList]); 

    // useEffect for calculating historical aggregate totals on showHistoricalAggregateDataList change
    useEffect(() => {
        calculateAggregateTotals(historicalTotalsDataList, setHistoricalTotalsDataList, showHistoricalAggregateDataList).then(res => {
            // console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
    }, [showHistoricalAggregateDataList]); 

    // useEffect for calculating aggregate totals on showConsortiumDataList change
    useEffect(() => {
        consortiumCalculateAggregateTotals(consortiumTotalsDataList, setConsortiumTotalsDataList, showConsortiumDataList).then(res => {
            // console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
    }, [showConsortiumDataList]); 

    // useEffect to filter company id list table for active/inactive
    useEffect(() => {
        if (!initialRender10.current){
            const functionList = [
                {function: statusFilter, value: showInactiveSubcompanies, flag: 1, cols: ['active']}, 
            ];
            let filteredList = applyFilters(subCompanyTableDataList, functionList);
            setShowSubCompanyTableDataList(showSubCompanyTableDataList => showSubCompanyTableDataList = filteredList);
        }
        else {
            initialRender10.current = false;
        }
    }, [showInactiveSubcompanies, triggerFilter]);

    // use Effect to run on initial render to set tabs
    useEffect(() => {
        setTabList(tabList => tabList = getPageTabs(pageTabs)); 
    }, []); 

    // object to pass variables to context
    const settings = {
        editRow, 
        setEditRow, 
        overrideModal, 
        setOverrideModal,
        workflowModal, 
        setWorkflowModal, 
        workflowAction, 
        setWorkflowAction, 
        workflowNewStatus, 
        setWorkflowNewStatus, 
        aggregateDataList, 
        aggregateTableHeader, 
        workflowButtonCss, 
        workflowOptOut, 
        workflowReviewAction, 
        editPayoutTypeModal, 
        setEditPayoutTypeModal, 
        aggregateTableHeader, 
        overrideTypeList, 
        subCompany, 
        overrideType, 
        setOverrideType, 
        getCompanyPayoutViewPageData, 
        snackbarAlert, 
        showSnackbar, 
        setShowSnackbar,
        snackbarMessage, 
        snackbarColor, 
        userEntitlementId,
        showAggregateDataList,  
        workflowAggregateTableHeader, 
        workflowAggregateDataList, 
        status, 
        getCompanyPayoutViewPageData,
        snackbarAlert, 
        showAddAdhocModal, 
        setShowAddAdhocModal, 
        subCompanyList, 
        masterCompanyId, 
        showEditAdhocModal, 
        setShowEditAdhocModal, 
        editAdhocRow, 
        setEditAdhocRow, 
        enableReopen, 
        rebateInputTypeId, 
        showContractCommentModal, 
        setShowContractCommentModal,
        contractUploadRow, 
        setContractUploadRow,
        workflowActionId, 
        setWorkflowActionId, 
        showMarkPaymentFailedModal, 
        setShowMarkPaymentFailedModal, 
        markPaymentFailedRow, 
        setMarkPaymentFailedRow, 
        adhocTableHeader,
        showSpinner, 
        isLoading, 
        setIsLoading, 
        spendPieData, 
        setSpendPieData, 
        spendBarData, 
        setSpendBarData, 
        spendBarKeys, 
        setSpendBarKeys, 
        showSpendBarKeys, 
        setShowSpendBarKeys, 
        spendBarFilter, 
        setSpendBarFilter, 
        spendBarFilterList, 
        spendBarYAxis,
        totalAggregateSpend,  
        spendLineData, 
        showSpendLineKeys, 
        spendLineFilter, 
        setSpendLineFilter, 
        spendLineFilterList,
        spendLineXAxis, 
        setSpendLineXAxis,  
        showSpendLineYAxis, 
        monthlyLineData, 
        setMonthlyLineData, 
        monthlyLineKeys, 
        setMonthlyLineKeys, 
        showMonthlyLineKeys, 
        setShowMonthlyLineKeys, 
        monthlyLineXAxis, 
        setMonthlyLineXAxis,
        monthlyLineYAxis, 
        setMonthlyLineYAxis,
        showMonthlyLineYAxis, 
        setShowMonthlyLineYAxis, 
        monthlyLineFilter, 
        setMonthlyLineFilter,  
        monthlyLineFilterList, 
        setMonthlyLineFilterList,  
        onSpendPieClick, 
        fullRefresh, 
        adhocInputConfig, 
        adhocInputLists, 
        masterCompanyData, 
        editSubCompanyModal, 
        setEditSubCompanyModal, 
        editSubCompanyRow, 
        setEditSubCompanyRow, 
        editAccountIdsModal, 
        setEditAccountIdsModal
    };


    //  show status color
    const showStatus = (value) => {
        // set color based on value
        let color = '#4472C4'; 
        let textColor = 'white'
        if (value == 'Pending'){
            color = '#FFC700'; 
            textColor = 'black'; 
        }
        else if (value == 'Rejected'){
            color = '#EB0000'; 
            textColor = 'white'; 
        }
        else if (value == 'Initial Review'){
            color = '#7E79DD'; 
            textColor = 'white'; 
        }
        else if (value == 'Final Review'){
            color = '#00A6CA'
            textColor = 'white'; 
        }
        else if (value == 'Accepted'){
            color = '#008A00';
            textColor = 'white'; 
        }
        // show text with color
        return (
            <div className="d-flex justify-content-start align-items-center gap-1">
              <Box
                sx={{
                  minWidth: 12,
                  height: 12,
                  bgcolor: color,
                  borderRadius: 100,
                }}
              />
              <div>{value}</div>
            </div>
          );
    }

    return(
        <div class='summary-page'>
            {/* wrap children so they have access to variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header banner and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* all modals that can be activated. By default they are initialized in hidden state */}
                <OverrideModal/> 
                <WorkflowModal/> 
                <EditPayoutTypeModal defaultFlag={0}/>
                <AddAdhocPaymentModal refreshFunction={fullRefresh}/>
                <EditAdhocPaymentModal refreshFunction={fullRefresh}/>
                <MarkPaymentFailedModal refreshFunction={fullRefresh}/>
                <ContractUploadCommentModal />
                <EditAccountIdsModal />
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                {/* top label to view company info */}
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        <div className="mb-1" style={{ borderRadius: "12px", background: "white" }}>
                            <div className="d-flex p-3 flex-wrap gap-3">
                                <div className="pe-3">
                                    <InfoLabel title={process.env.REACT_APP_MASTER_COMPANY_NAME_TAG + ': '} content={company}/>
                                </div>
                                <div class="vr me-3"></div>
                                <div className="pe-3">
                                    <InfoLabel title={'Payout Cycle: '} content={formatDate(companyInfo['cyclestart']) + ' to ' + formatDate(companyInfo['cycleend']) + ' [' + companyInfo['incentivefreq'] + ']'}/>
                                </div>   
                                <div class="vr me-3"></div> 
                                <div className="pe-3">
                                    <InfoLabel title={'Porfolio: '} content={companyInfo['incentivetype']}/>
                                </div>   
                                <div class="vr me-3"></div> 
                                <div className="pe-3">
                                    <InfoLabel title={'Company Type: '} content={companyInfo['companytypedescription']}/>
                                </div>  
                            </div>
                        </div>
                        { process.env.REACT_APP_SHOW_CLIENT_INFO_UPDATE_ALERTS == '1' ? 
                            <>
                                <BannerAlert
                                    show={showClientInfoUpdateAlert}
                                    setShow={setShowClientInfoUpdateAlert}
                                    type="warning"
                                    message={
                                        <Typography sx={{ fontSize: "14px", lineHeight: "24px" }}>
                                        <b>Client info has been updated.</b> Allow process to run
                                        overnight to see aggregation with changes.
                                        </Typography>
                                    }
                                />                            
                            </>
                        :<></>}
                        <div className="flex-grow-1 mt-1">
                            <div style={{ background: "white" ,borderRadius: "12px"}} >
                                <div className="d-flex align-items-center justify-content-between" style={{flexWrap:'wrap'}}> 
                                    <div className="d-flex p-2 ps-3 pe-3 align-items-center" style={{flexWrap:'wrap'}}>
                                        <div className="pe-3">
                                            <PageDropdown tag='Period: ' value={periodId} setValue={setPeriodId} list={periodList} width={"6rem"}/>
                                        </div>
                                        <div className="pe-3">
                                            <PageDropdown tag='Company ID: ' value={subCompany} setValue={setSubCompany} list={subCompanyList} width={"6rem"}/>
                                        </div>
                                        <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableReset ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableReset ? resetToDefault() : null}>
                                            Reset All
                                        </div>
                                    </div>
                                    <div className="d-flex p-2 ps-3 pe-3 align-items-center">
                                        <div className="pe-3">
                                            <RebateSummaryIndicator  show={companyInfo['indicator']} ids={companyInfo['indicatorid']} tooltip={companyInfo['tooltip']} />
                                        </div>  
                                        <div className="pe-2">
                                            <InfoLabel title={"Payout Status: "} content={showStatus(status)} />
                                        </div>     
                                        <div>
                                            {/* workflow button component that changes dynamically based on status and user entitlement */}
                                            <WorkflowButton disable={disableWorkflowButton} />
                                        </div> 
                                    </div>         
                                </div>
                                {/* tabs component for navigation between sections without leaving page */}
                                <div>
                                    <PageTabs value={tabValue} setValue={setTabValue} tabList={tabList}/>
                                </div>
                                <div className="p-3">
                                    {/* logic to show different sections based on the tab that has been chosen */}
                                    { tabValue == 0 ?
                                        <div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex gap-3 align-items-center">
                                                    <PageDropdown alignContent='left' tag='Sub Companies' list={activeTypeList} value={showInactiveSubcompanies} setValue={setShowInactiveSubcompanies} width={'7rem'} />
                                                    <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${showInactiveSubcompanies === defaultCheckboxDropdownState ? '#BDBDBD' : '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => showInactiveSubcompanies === defaultCheckboxDropdownState ? null : setShowInactiveSubcompanies(defaultCheckboxDropdownState)}>
                                                        Reset All
                                                    </div>
                                                </div>
                                            </div>
                                            <hr className="m-0 mb-2 mt-2" />
                                            <div>
                                                <TableName>Company ID List</TableName>
                                                <OrderedDataTable varHeight="450px" sortingEnabled={true} RowComponent={SubCompanyRowComponent} dataList={showSubCompanyTableDataList} tableHeader={subCompanyTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                            </div>
                                        </div>
                                    : tabValue == 1 ?
                                        <div style={{ maxHeight: "calc(100vh - 390px)", overflow: "overlay" }}>
                                            {/* <div>
                                                <PageToggleButtonGroup alignment={radioKey} setAlignment={setRadioKey} buttonList={radioButtons} />
                                            </div> */}
                                            { radioKey == 1 ? 
                                            <>
                                                <div>
                                                    <PayoutDetailsGraphs />
                                                </div>
                                            </>
                                            :<>
                                                <div>
                                                    <div className="d-flex flex-wrap gap-3 mb-3">
                                                        <div style={{ flex: '1 1 420px', minWidth: 0 }}>
                                                            <TableName>Program Level Aggregate</TableName>
                                                            <OrderedDataTable disableMaxTableHeight={true} RowComponent={ProgramLevelAggregateRowComponent} dataList={showProgramLevelAggregateDataList} tableHeader={programLevelAggregateTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='7vh' FooterComponent={ProgramLevelFooterComponent} footerObj={programLevelTotals} stickyFirstColumnEnabled={true}/>
                                                        </div>
                                                        <div style={{ flex: '1 1 420px', minWidth: 0 }}>
                                                            <TableName>Program Adjustment</TableName>
                                                            <OrderedDataTable disableMaxTableHeight={true} RowComponent={ProgramAdjustmentRowComponent} dataList={showProgramAdjustmentDataList} tableHeader={programAdjustmentTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='7vh' stickyFirstColumnEnabled={true}/>
                                                        </div>
                                                    </div>
                                                    <TableName>Rebate Cycle Aggregate</TableName>
                                                    <OrderedDataTable disableMaxTableHeight={true} sortingEnabled={true} RowComponent={CurrentAggregateRowComponent} dataList={showAggregateDataList} tableHeader={aggregateTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='7vh' FooterComponent={FooterComponent} footerObj={aggregateTotalsDataList} stickyFirstColumnEnabled={true}/>
                                                </div>
                                            </>}
                                        </div>
                                    : tabValue == 2 ?
                                        <div>
                                            <div>
                                                { periodListHistorical.length == 0 ? 
                                                <div className="d-flex p-3">
                                                    <InfoLabel content={"No Historical Rebate Cycles Found"} />
                                                </div>
                                                :<div className="d-flex p-3">
                                                    <div className="pe-3">
                                                        <PageReadOnlyInput tag='Historical Cycle: ' value={formatDate(historicalCycleStart) + ' to ' + formatDate(historicalCycleEnd)} width='17vw'/>
                                                    </div>
                                                    <div className="pe-3">
                                                        {/* <PageReadOnlyInput tag='Status: ' value={'Accepted'}/> */} 
                                                    </div>
                                                    <div className="pe-3">
                                                        <PageDropdown tag='Historical Period: ' value={periodIdHistorical} setValue={setPeriodIdHistorical} list={periodListHistorical} width={"6rem"}/>
                                                    </div>
                                                    <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableResetHistoricalCycle ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableResetHistoricalCycle ? resetToDefaultHistoricalCycle() : null}>
                                                        Reset All
                                                    </div>

                                                </div>}                            
                                            </div>
                                            <hr style={{ marginTop: 0 }} />
                                            <div style={{ maxHeight: "calc(100vh - 480px)", overflow: "overlay" }}>
                                                <div>
                                                    <div className="d-flex flex-wrap gap-3 mb-3">
                                                        <div style={{ flex: '1 1 420px', minWidth: 0 }}>
                                                            <TableName>Program Level Aggregate</TableName>
                                                            <OrderedDataTable disableMaxTableHeight={true} RowComponent={ProgramLevelAggregateRowComponent} dataList={historicalProgramLevelAggregateDataList} tableHeader={historicalProgramLevelAggregateTableHeader} showSpinner={showSpinnerHistorical} numToPage={25} skeletonHeight='7vh' FooterComponent={ProgramLevelFooterComponent} footerObj={historicalProgramLevelTotals} stickyFirstColumnEnabled={true}/>
                                                        </div>
                                                        <div style={{ flex: '1 1 420px', minWidth: 0 }}>
                                                            <TableName>Program Adjustment</TableName>
                                                            <OrderedDataTable disableMaxTableHeight={true} RowComponent={ProgramAdjustmentRowComponent} dataList={showHistoricalProgramAdjustmentDataList} tableHeader={historicalProgramAdjustmentTableHeader} showSpinner={showSpinnerHistorical} numToPage={25} skeletonHeight='7vh' stickyFirstColumnEnabled={true}/>
                                                        </div>
                                                    </div>
                                                    <TableName>Rebate Cycle Aggregate</TableName>
                                                    <OrderedDataTable disableMaxTableHeight={true} sortingEnabled={true} RowComponent={HistoricalAggregateRowComponent} dataList={showHistoricalAggregateDataList} tableHeader={historicalAggregateTableHeader} showSpinner={showSpinnerHistorical} numToPage={25} skeletonHeight='7vh' FooterComponent={FooterComponent} footerObj={historicalTotalsDataList} stickyFirstColumnEnabled={true}/>
                                                </div>
                                            </div>
                                        </div>
                                    : tabValue == 3 ?
                                        <div className="d-flex flex-column gap-2">
                                            <PageToggleButtonGroup adjacentButtonEnabled={false} alignment={monthlyBreakupRadioKey} setAlignment={setMonthlyBreakupRadioKey} buttonList={monthlyBreakupRadioButtons} />
                                            <hr style={{margin:0,height:'1px'}}/>
                                            { monthlyBreakupRadioKey == 1 ?
                                                <>
                                                    { periodListHistorical.length == 0 ?
                                                    <div className="d-flex p-1">
                                                        <InfoLabel content={"No Historical Rebate Cycles Found"} />
                                                    </div>
                                                    :<div className="d-flex align-items-center">
                                                        <div className="pe-3">
                                                            <PageReadOnlyInput tag='Historical Cycle: ' value={formatDate(historicalCycleStart) + ' to ' + formatDate(historicalCycleEnd)} width='17vw'/>
                                                        </div>
                                                        <div className="pe-3">
                                                            <PageDropdown tag='Historical Period: ' value={periodIdHistorical} setValue={setPeriodIdHistorical} list={periodListHistorical} width={"6rem"}/>
                                                        </div>
                                                        <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableResetHistoricalCycle ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableResetHistoricalCycle ? resetToDefaultHistoricalCycle() : null}>
                                                            Reset All
                                                        </div>
                                                    </div>}
                                                    <div style={{ maxHeight: "calc(100vh - 480px)", overflow: "overlay" }}>
                                                        <TableName>Monthly Breakup</TableName>
                                                        <OrderedDataTable disableMaxTableHeight={true} sortingEnabled={true} RowComponent={BreakupRowComponent} dataList={showHistoricalBreakupDataList} tableHeader={historicalBreakupTableHeader} showSpinner={showSpinnerHistorical} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true} />
                                                    </div>
                                                </>
                                            :<div style={{ maxHeight: "calc(100vh - 430px)", overflow: "overlay" }}>
                                                <TableName>Monthly Breakup</TableName>
                                                <OrderedDataTable disableMaxTableHeight={true} sortingEnabled={true} RowComponent={BreakupRowComponent} dataList={showBreakupDataList} tableHeader={breakupTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                            </div>}
                                        </div>
                                    : tabValue == 4 ? 
                                        <div>
                                            {rebateSetupsRadioKey === 1 ? 
                                            <div className="d-flex flex-column gap-2">
                                                <div>
                                                    {consortiumFlag === true ? 
                                                    <div>
                                                        <PageToggleButtonGroup adjacentButtonEnabled={false} alignment={rebateSetupsRadioKey} setAlignment={setRebateSetupsRadioKey} buttonList={rebateSetupsRadioButtons} />        
                                                    </div>
                                                    : <></>}
                                                </div>
                                                {consortiumFlag === true && <hr style={{margin:0,height:'1px'}}/>}
                                                <div className="d-flex align-items-center" >
                                                    <div className='pe-3' >
                                                        <PageDropdown width = {"9em"} tag='Rebate Setup Type' value={consortiumRebateSetupTypeFilter} setValue={setConsortiumRebateSetupTypeFilter} list={rebateSetupTypeList}/>
                                                    </div>
                                                    <div className='pe-3' >
                                                        <PageDropdown width = {"7em"} tag='Product Type' value={consortiumProductFilter} setValue={setConsortiumProductFilter} list={productFilterList}/>
                                                    </div>
                                                    <div className='pe-3' >
                                                        <PageDropdown width = {"9em"} tag='Fee Category' value={consortiumFeeCategoryFilter} setValue={setConsortiumFeeCategoryFilter} list={feeCategoryFilterList} />    
                                                    </div>
                                                    <div className='pe-3' >
                                                        <PageDropdown width = {"7em"} tag='Billing Rate' value={consortiumBillingRateFilter} setValue={setConsortiumBillingRateFilter} list={billingRateFilterList}/>
                                                    </div>
                                                    <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableResetRebateSetups1 ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableResetRebateSetups1 ? resetToDefaultRebateSetups1() : null}>
                                                        Reset All
                                                    </div>
                                                </div>
                                                {!showSpinner && <hr style={{margin:0,height:'1px'}}/>}
                                                <RebateComponentDisplay tag='Consortium Rebate Components:' values={consortiumRebateComponentValues} setValues={setConsortiumRebateComponentValues} config={rebateComponentConfig} portfolioId={masterCompanyData} showOverride={!showSpinner} entitledBool={false} onClick={()=>{return}} />
                                                <div>
                                                    <TableName>Consortium Rebate Setups</TableName>
                                                    <OrderedDataTable varHeight='605px' sortingEnabled={true} RowComponent={RebateSetupRowComponent} dataList={showConsortiumRebateSetupDataList} tableHeader={consortiumRebateSetupTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                                </div>
                                            </div>
                                            : <div className="d-flex flex-column gap-2">
                                                <div>
                                                    {consortiumFlag === true ? 
                                                    <div>
                                                        <PageToggleButtonGroup adjacentButtonEnabled={false} alignment={rebateSetupsRadioKey} setAlignment={setRebateSetupsRadioKey} buttonList={rebateSetupsRadioButtons} />
                                                    </div>
                                                    : <></>}
                                                </div>
                                                {consortiumFlag === true && <hr style={{margin:0,height:'1px'}}/>}
                                                <div className="d-flex align-items-center">
                                                    <div className='pe-3'>
                                                        <PageDropdown width = {"9em"} tag='Rebate Setup Type' value={rebateSetupTypeFilter} setValue={setRebateSetupTypeFilter} list={rebateSetupTypeList}/>
                                                    </div>
                                                    <div className='pe-3'>
                                                        <PageDropdown width = {"7em"} tag='Product Type' value={productFilter} setValue={setProductFilter} list={productFilterList}/>
                                                    </div>
                                                    <div className='pe-3'>
                                                        <PageDropdown width = {"9em"} tag='Fee Category' value={feeCategoryFilter} setValue={setFeeCategoryFilter} list={feeCategoryFilterList} />    
                                                    </div>
                                                    <div className='pe-3'>
                                                        <PageDropdown width = {"7em"} tag='Billing Rate' value={billingRateFilter} setValue={setBillingRateFilter} list={billingRateFilterList}/>
                                                    </div>
                                                    <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableResetRebateSetups2 ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableResetRebateSetups2 ? resetToDefaultRebateSetups2() : null}>
                                                        Reset All
                                                    </div>
                                                </div>
                                                {!showSpinner && <hr style={{margin:0,height:'1px'}}/>}
                                                <RebateComponentDisplay tag='Rebate Components:' values={rebateComponentValues} setValues={setRebateComponentValues} config={rebateComponentConfig} portfolioId={masterCompanyData} showOverride={!showSpinner} entitledBool={false} onClick={()=>{return}} />
                                                <div>
                                                    <TableName>Rebate Setups</TableName>
                                                    <OrderedDataTable varHeight={consortiumFlag ? '655px':'605px'} sortingEnabled={true} RowComponent={RebateSetupRowComponent} dataList={showRebateSetupDataList} tableHeader={rebateSetupTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                                </div>
                                            </div>}
                                        </div>
                                    : tabValue == 5 ?
                                        <div>
                                            <TableName>Cycle Payout Info</TableName>
                                            <OrderedDataTable varHeight={'435px'} sortingEnabled={true} RowComponent={PayoutInfoRowComponent} dataList={payoutInfoDataList} tableHeader={payoutInfoTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/> 
                                        </div>
                                    : tabValue == 6 ? 
                                        <div> 
                                            {adhocEditBool && <div className="d-flex mb-2 align-items-center justify-content-end">
                                                <ButtonComponent tag='Add Adhoc-Payment' onButtonClick={()=>setShowAddAdhocModal(showAddAdhocModal => showAddAdhocModal = true)}  border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'} width='max-content'/>
                                                {/* <EntitledButton entitledBool={adhocEditBool} tag='Add Adhoc-Payment' cssClass='table-add-button' onClick={()=>setShowAddAdhocModal(showAddAdhocModal => showAddAdhocModal = true)}/> */}
                                            </div>}
                                            {adhocEditBool && <hr style={{ marginTop: 0 }} />}
                                            <div>
                                                <TableName>Payment History</TableName>
                                                <OrderedDataTable varHeight={adhocEditBool ? "500px" : "435px"} sortingEnabled={true} RowComponent={AdhocRowComponent} dataList={adhocDataList} tableHeader={adhocTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/> 
                                            </div>
                                        </div>
                                    : tabValue == 7 ? 
                                        <div>
                                            <TableName>Upload Client Contracts</TableName>
                                            <OrderedDataTable varHeight='440px' sortingEnabled={true} RowComponent={UploadContractRowComponent} tableHeader={uploadContractsTableHeader} dataList={uploadContractsDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                        </div>
                                    : tabValue == 8 ? 
                                        <div>
                                            <div className="d-flex mb-2 align-items-center">
                                                <InfoLabel title={"Consortium ID: "} content={consortiumId}/>
                                            </div>
                                            <hr style={{ marginTop: 0 }} />
                                            <div>
                                                <TableName>Consortium View</TableName>
                                                <OrderedDataTable varHeight='485px' sortingEnabled={true} RowComponent={ConsortiumViewRowComponent} dataList={showConsortiumDataList} tableHeader={consortiumTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='7vh' FooterComponent={ConsortiumFooterComponent} footerObj={consortiumTotalsDataList} stickyFirstColumnEnabled={true}/>
                                            </div>
                                        </div>
                                    : <></> }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    );
}

export default CompanyPayoutView;